import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paths } from 'shared/routes/paths';

import { HistoryContext } from './context';

export const useBackFunction = (fallbackPath: Paths) => {
  const { pathStack } = useContext(HistoryContext);
  const navigate = useNavigate();

  return useCallback(
    () =>
      pathStack.length > 1 ? window.history.back() : navigate(fallbackPath),
    [fallbackPath, pathStack.length, navigate],
  );
};
